import { Buffer } from 'buffer';

const toBase64Url = (b64: string): string => {
    let out = b64.replace(/\+/g, '-').replace(/\//g, '_');

    if (out.endsWith('=')) {
        out = out.slice(0, out.endsWith('==') ? -2 : -1);
    }

    return out;
};

export const base64Url = (bytes: Uint8Array): string =>
    toBase64Url(Buffer.from(bytes).toString('base64'));
